/**
 * 屏幕变
 * 区分移动设备
 */
const { body } = document;
const WIDTH = 1024;
const RATIO = 3;



export default {
  beforeMount() {
    window.addEventListener('resize', this.resizeHandler, false)
  },
  mounted() {
    this.resizeHandler()
  },
  methods: {
    isMobile() {
      const rect = body.getBoundingClientRect();
      return rect.width - RATIO < WIDTH
    },
    resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.isMobile();
        console.log('mixins resize');
        this.$store.dispatch('toggleDevice', isMobile)
      }
    }
  }
}
